import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Toolbar,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HouseIcon from '@mui/icons-material/House';
import { DataGrid } from 'react-data-grid';
import { toast } from 'react-toastify';
import _ from 'lodash';

import DefaultApi from '../../Api/DefaultApi';
import ConfirmDialog from '../../Components/ConfirmDialog';
import { renderTextEditor } from '../../Components/ReactDataGridProps';
import { creators as PManagementActions } from '../../Reducers/PManagement';
import appdata from '../../Services/appdata';
import './style.css';


function rowKeyGetter(row) {
  return row.id;
}

export default function PackageManagement() {
  const packageSettings = useSelector(
    (state) => state.PManagement.packageSettings,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(-1);
  const [packageDetailModal, setPackageDetailModal] = useState(false);
  const [packageName, setPackageName] = useState('');
  const [packageAmountAud, setPackageAmountAud] = useState(0.0);
  const [packageAmountUsd, setPackageAmountUsd] = useState(0.0);
  const [packageAmountEur, setPackageAmountEur] = useState(0.0);
  const [packageAmountGbp, setPackageAmountGbp] = useState(0.0);
  const [userLimit, setUserLimit] = useState(0);
  const [freeable, setFreeable] = useState(false);
  const [packageSettingTablecolumns, setPackageSettingTablecolumns] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState({
    open: false,
    title: '',
    content: '',
    deleteModal: false,
  });

  useEffect(() => {
    dispatch(PManagementActions.pmanagementGetPackageSettings());
  }, [dispatch]);

  const onPackageDetailModal = () => {
    setPackageDetailModal(true);
  };

  const onPackageDetailModalClose = () => {
    setPackageDetailModal(false);
  };

  const handleCellClick = (rowData) => {
    if (selectedRowId !== rowData.row.id) {
      setSelectedRowId(rowData.row.id);
    }
  };

  const handleRowChange = async (updatedRows, field) => {
    setRows(updatedRows);
    let updated_data = {
      rowIds: [updatedRows[field.indexes[0]].id],
      updated: {
        [field.column.key]: updatedRows[field.indexes[0]][field.column.key],
      },
    };

    let tableUpdatedData = {
      rowId: updatedRows[field.indexes[0]].id,
      pkgId: updatedRows[field.indexes[0]].id,
      colId: field.column.key,
      changedValue: updated_data.updated[field.column.key],
    };

    DefaultApi.updatePackageSetting(JSON.stringify(tableUpdatedData))
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => toast.error(error.message));
  };

  const onClickedPackageDelete = () => {
    if (selectedRowId > -1) {
      setOpenConfirmDialog({
        open: true,
        title: 'Delete Package',
        content: 'Are you sure to delete this pakage?',
        deleteModal: true,
      });
    }
  };

  const handleDeletePackage = () => {
    DefaultApi.deletePackage(selectedRowId)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message);
          setSelectedRowId(-1);
          dispatch(PManagementActions.pmanagementGetPackageSettings());
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => toast.error(error.message));
  }
  

  const handlePackageStatusChange = async (event) => {    
    if (selectedRowId > -1) {
      const changeValue = event.target.value;
      packageSettings[selectedRowId].status = changeValue;
      const pkgId = packageSettings[selectedRowId].id;
      let tableUpdatedData = {
        rowId: selectedRowId,
        pkgId,
        colId: 'status',
        changedValue: changeValue,
      };

      DefaultApi.updatePackageSetting(JSON.stringify(tableUpdatedData))
        .then((res) => {
          if (res.status === 200) {
            toast.success(res.message);
            dispatch(PManagementActions.pmanagementGetPackageSettings());
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => toast.error(error.message));
    }
  };

  const handlePackageChange = async (event) => {
    if (selectedRowId > -1) {
      let updatedPackageSettings = [...packageSettings];
      const changeValue = event.target.checked;
      const el_id = event.target.id;
      const colName = document
        .getElementById(el_id)
        .parentNode.parentNode.getAttribute('data');

      const pkgId = updatedPackageSettings[selectedRowId].id;
      const packageData = JSON.parse(updatedPackageSettings[selectedRowId].pages);
      packageData[colName] = changeValue;
      updatedPackageSettings[selectedRowId].pages = JSON.stringify(packageData);
      let tableUpdatedData = {
        rowId: selectedRowId,
        pkgId,
        colId: 'pages',
        changedValue: JSON.stringify(packageData),
      };
      DefaultApi.updatePackageSetting(JSON.stringify(tableUpdatedData))
        .then((res) => {
          if (res.status === 200) {
            toast.success(res.message);
            dispatch(PManagementActions.pmanagementGetPackageSettings());
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => toast.error(error.message));
    }
  };

  const handlePackageNameChange = (event) => {
    setPackageName(event.target.value);
  };

  const handlePackageFreeableChange = () => {
    setPackageAmountAud(0);
    setPackageAmountUsd(0);
    setPackageAmountEur(0);
    setPackageAmountGbp(0);
    setFreeable(!freeable);
  };

  const handlePackageAmountAudChange = (event) => {
    setPackageAmountAud(event.target.value);
  };

  const handlePackageAmountUsdChange = (event) => {
    setPackageAmountUsd(event.target.value);
  };

  const handlePackageAmountEurChange = (event) => {
    setPackageAmountEur(event.target.value);
  };

  const handlePackageAmountGbpChange = (event) => {
    setPackageAmountGbp(event.target.value);
  };

  const handleUserLimitChange = (event) => {
    setUserLimit(event.target.value);
  };

  const handleAddPackageModalPayment = async () => {
    if (packageName === '') {
      toast.warning('Please insert package name.');
    } else if (userLimit === 0 || userLimit === '') {
      toast.warning('Please insert user limit.');
    } else if (
      !freeable &&
      (packageAmountAud === 0 ||
        packageAmountAud === '' ||
        packageAmountUsd === 0 ||
        packageAmountUsd === '' ||
        packageAmountEur === 0 ||
        packageAmountEur === '' ||
        packageAmountGbp === 0 ||
        packageAmountGbp === '')
    ) {
      toast.warning('Please insert package price.');
    } else {
      let updatedPackageSettingTablecolumns = [...packageSettingTablecolumns];
      let packageSet = {};
      updatedPackageSettingTablecolumns.forEach((col) => {
        if (col.isPackage) {
          packageSet[col.key] = 0;
        }
      });
      setPackageSettingTablecolumns(updatedPackageSettingTablecolumns);
      let packageInfo = {
        name: packageName,
        amount_aud: Math.round(packageAmountAud * 100),
        amount_usd: Math.round(packageAmountUsd * 100),
        amount_eur: Math.round(packageAmountEur * 100),
        amount_gbp: Math.round(packageAmountGbp * 100),
        userLimit,
        freeable,
        packageSet: JSON.stringify(packageSet),
      };
      DefaultApi.addPackageSetting(packageInfo)
        .then((res) => {
          if (res.status === 200) {
            toast.success(res.message);
            getPackageSettings();
            setPackageAmountAud(0);
            setPackageAmountUsd(0);
            setPackageAmountEur(0);
            setPackageAmountGbp(0);
            setPackageName('');
            setUserLimit(0);
            setFreeable(false);
            onPackageDetailModalClose();
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => toast.error(error.message));
    }
  };

  const onSignout = () => {
    appdata.localClear();
    appdata.clear();
  };

  const tableColumns = useMemo(() => {
    let package_table_columns = [
      {
        key: 'id',
        name: 'ID',
        width: 40,
        sortable: true,
        isPackage: false,
      },
      {
        key: 'name',
        name: 'Package Name',
        sortable: true,
        filterable: true,
        width: '8%',
        editable: renderTextEditor,
        isPackage: false,
      },
      {
        key: 'status',
        name: 'Status',
        sortable: true,
        filterable: true,
        width: 110,
        isPackage: false,
        component: 'select',
      },
      {
        key: 'userlimit',
        name: 'User Limit',
        sortable: true,
        filterable: true,
        width: '6%',
        editable: renderTextEditor,
        isPackage: false,
      },
      {
        key: 'amount_aud',
        name: 'Amount (AUD)',
        sortable: true,
        filterable: true,
        width: '6%',
        isPackage: false,
      },
      {
        key: 'amount_usd',
        name: 'Amount (USD)',
        sortable: true,
        filterable: true,
        width: '6%',
        isPackage: false,
      },
      {
        key: 'amount_eur',
        name: 'Amount (EUR)',
        sortable: true,
        filterable: true,
        width: '6%',
        isPackage: false,
      },
      {
        key: 'amount_gbp',
        name: 'Amount (GBP)',
        sortable: true,
        filterable: true,
        width: '6%',
        isPackage: false,
      },
    ];

    let _packageSettings = [];
    if (packageSettings.length > 0) {
      packageSettings.map((pkg) => {
        pkg.amount_aud = Math.round(pkg.amount_aud * 100) / 100;
        pkg.amount_eur = Math.round(pkg.amount_eur * 100) / 100;
        pkg.amount_gbp = Math.round(pkg.amount_gbp * 100) / 100;
        pkg.amount_usd = Math.round(pkg.amount_usd * 100) / 100;
        let _pkg = { ...pkg };
        let pages = JSON.parse(pkg.pages);
        package_table_columns.forEach((col) => {
          if (col.component === 'select') {
            _pkg[col.key] = (
              <FormControl fullWidth={true}>
                <InputLabel htmlFor="status-select">Status</InputLabel>
                <Select
                  value={pkg[col.key]}
                  onChange={handlePackageStatusChange}
                  inputProps={{
                    name: 'status',
                    id: 'status-select',
                  }}
                  title={col.name}
                  style={{ width: '100%' }}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                </Select>
              </FormControl>
            );
          } else if (col.component === 'checkbox') {
            _pkg[col.key] = (
              <Checkbox
                id={pkg.id.toString() + col.key}
                value={pages[col.key] && pages[col.key].toString()}
                checked={Boolean(pages[col.key])}
                data={col.key}
                title={col.key}
                onChange={handlePackageChange}
                color="success"
              ></Checkbox>
            );
          }
        });
        _packageSettings.push(_pkg);
        return true;
      });
    }
    setRows(_packageSettings);

    return package_table_columns;
    // eslint-disable-next-line
  }, [packageSettings]);

  return (
    <div style={{ height: '100%' }}>
      <AppBar position="relative" color="default">
        <Toolbar>
          <IconButton onClick={() => navigate('/')}>
            <HouseIcon />
          </IconButton>
          <IconButton onClick={onSignout} className="sign-out-but">
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <div className="PackageManagement">
        <Paper className="grid-paper">
          <div
            style={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}
          >
            <div style={{ flex: 1 }} />
            <IconButton aria-label="Add" onClick={onPackageDetailModal}>
              <AddIcon />
            </IconButton>
            <IconButton aria-label="Delete" onClick={onClickedPackageDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
          <DataGrid
            rowKeyGetter={rowKeyGetter}
            className={'fill-grid rdg-light'}
            columns={tableColumns}
            rows={rows}
            onCellClick={handleCellClick}
            onRowsChange={handleRowChange}
            rowHeight={50}
            style={{ maxHeight: window.innerHeight - 140, resize: 'both' }}
          />
        </Paper>
        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={packageDetailModal}
          onClose={onPackageDetailModalClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">Package Detail</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please enter detail of the package.
            </DialogContentText>
          </DialogContent>
          <Grid
            container
            justifyContent="center"
            className="packagedetail_modal_content"
          >
            <Grid size={10}>
              <TextField
                id="packageName"
                label="Package Name"
                value={packageName}
                onChange={handlePackageNameChange}
                margin="normal"
                fullWidth={true}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id={'freeable'}
                    value={freeable}
                    checked={freeable}
                    data={'Free Package'}
                    title={'Free Package'}
                    onChange={handlePackageFreeableChange}
                    color="success"
                  ></Checkbox>
                }
                label="Free Package"
              />
              {freeable ? (
                ''
              ) : (
                <>
                  <TextField
                    id="amount_aud"
                    label="Price (AUD)"
                    value={packageAmountAud}
                    onChange={handlePackageAmountAudChange}
                    margin="normal"
                    fullWidth={true}
                  />
                  <TextField
                    id="amount_usd"
                    label="Price (USD)"
                    value={packageAmountUsd}
                    onChange={handlePackageAmountUsdChange}
                    margin="normal"
                    fullWidth={true}
                  />
                  <TextField
                    id="amount_Eur"
                    label="Price (EUR)"
                    value={packageAmountEur}
                    onChange={handlePackageAmountEurChange}
                    margin="normal"
                    fullWidth={true}
                  />
                  <TextField
                    id="amount_gbp"
                    label="Price (GBP)"
                    value={packageAmountGbp}
                    onChange={handlePackageAmountGbpChange}
                    margin="normal"
                    fullWidth={true}
                  />
                </>
              )}
              <TextField
                id="userLimit"
                label="User Limit"
                value={userLimit}
                onChange={handleUserLimitChange}
                margin="normal"
                fullWidth={true}
              />
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            className="packagedetail_modal_footer"
          >
            <Button
              onClick={handleAddPackageModalPayment}
              variant="raised"
              color="primary"
            >
              Continue
            </Button>
            <Button
              onClick={onPackageDetailModalClose}
              variant="raised"
              color="primary"
            >
              Close
            </Button>
          </Grid>
        </Dialog>
      </div>

      <ConfirmDialog
        open={openConfirmDialog.open}
        title={openConfirmDialog.title}
        content={openConfirmDialog.content}
        deleteModal={openConfirmDialog.deleteModal}
        onClose={() => setOpenConfirmDialog({ ...openConfirmDialog, open: false })}
        onConfirm={handleDeletePackage}
      />
    </div>
  );
}
